const styleMap = {
  BOLD: {
    fontWeight: 600,
  },
};

export default styleMap;
